import $ from 'jquery';
import PromoCarousel from './PromoCarousel';

export default () => {
  if ($('[data-promo-carousel]').length === 0) {
    return;
  }

  $('[data-promo-carousel]').each((i, promo_carousel) => {
    const $promo_carousel = $(promo_carousel);

    if (!$promo_carousel.attr('initialized')) {
      new PromoCarousel($promo_carousel);
      $promo_carousel.attr('initialized', true);
    }
  });
};
